import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getIdentityQueryKey from './get-query-key';

/**
 * getFetchIdentityOptions provides the query options for identity data.
 * Note: This should primarily be used within React components via useFetchIdentity.
 * For non-React contexts, use webShellClient.identity functions directly to prevent stale data.
 */
var getFetchIdentityOptions = function getFetchIdentityOptions() {
  return {
    queryKey: getIdentityQueryKey(),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, token, visitData, isLoggedIn, isSwooshUser, userProfile;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return Promise.all([window.webShellClient.identity.getAccessToken(), window.webShellClient.identity.getVisitData(), window.webShellClient.identity.getIsLoggedIn(), window.webShellClient.identity.getIsSwooshUser(), window.webShellClient.identity.getUserProfile()]);
            case 1:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 5);
              token = _yield$Promise$all2[0];
              visitData = _yield$Promise$all2[1];
              isLoggedIn = _yield$Promise$all2[2];
              isSwooshUser = _yield$Promise$all2[3];
              userProfile = _yield$Promise$all2[4];
              return _context.abrupt("return", _objectSpread({
                visitId: (visitData === null || visitData === void 0 ? void 0 : visitData.visit) || (visitData === null || visitData === void 0 ? void 0 : visitData.visitId),
                visitorId: (visitData === null || visitData === void 0 ? void 0 : visitData.visitor) || (visitData === null || visitData === void 0 ? void 0 : visitData.visitorId),
                isLoggedIn: isLoggedIn,
                token: token,
                isSwooshUser: isSwooshUser,
                userInitialized: true
              }, userProfile));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: 0 // always want to refetch this data
  };
};
export default getFetchIdentityOptions;